import { lazy, Suspense } from 'react';
import type { TaskExtProps } from '../../../app/modules';
import { useSession } from '../../../app/session';
import { Skeleton } from '../../../components/ui/Skeleton';

/*
 * Розділ «ШІ-помічник» у картці задачі (для працівників з областю ai:use): підсумок (ШІ-3), перевірка
 * постановки (ШІ-2), для основної задачі матеріалу контенту — чернетка й перевірка статті (ШІ-26, ШІ-27).
 * Вміст завантажується ліниво; стан результатів скидається під час переходу до іншої задачі.
 */
const Body = lazy(() => import('./AiTaskPanelBody'));

export function AiTaskPanel(props: TaskExtProps) {
  const { can } = useSession();
  if (!can('ai:use')) return null;
  return (
    <Suspense
      fallback={
        <div role="status" aria-label="Завантаження ШІ-помічника" className="flex flex-col gap-2">
          <Skeleton className="h-3 w-48" />
          <Skeleton className="h-3 w-64" />
        </div>
      }
    >
      <Body key={props.task.id} {...props} />
    </Suspense>
  );
}
